import { MrModalDialog } from '@mrhenry/wp--mr-interactive';

class MrNotificationPopup extends MrModalDialog {
	override connectedCallback() {
		super.connectedCallback();

		requestAnimationFrame( () => {
			try {
				const now = new Date();
				const key = `remco-notification-popup:${this.getAttribute( 'edition' )}`;

				const notificationStorage = localStorage.getItem( key ) ?? 'false';

				if ( notificationStorage ) {
					const notificationObject = JSON.parse( notificationStorage );

					if ( notificationObject.expiration > now.getTime() ) {
						return;
					}
				}

				this.updateState( 'open' );
				const notificationKey = {
					expiration: now.getTime() + ( 24 * 60 * 60 * 1000 ), /* 24 hours */
				};
				localStorage.setItem( key, JSON.stringify( notificationKey ) );
			} catch ( err ) {
				console.warn( err );
			}
		} );
	}

	override async willOpen() {
		await super.willOpen();

		document.body.classList.add( 'has-open-overlay' );
	}

	override async willClose() {
		await super.willClose();

		document.body.classList.remove( 'has-open-overlay' );
	}
}

customElements.define( 'mr-notification-popup', MrNotificationPopup );
